module.exports = __webpack_public_path__ + "img/card_img_8.632a555a.png";